"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.VexillaClient = exports.VexillaFeatureType = void 0;
var axios_1 = require("axios");
var hasher_1 = require("./hasher");
var VexillaFeatureType;
(function (VexillaFeatureType) {
    VexillaFeatureType["TOGGLE"] = "toggle";
    VexillaFeatureType["GRADUAL"] = "gradual";
    VexillaFeatureType["SELECTIVE"] = "selective";
})(VexillaFeatureType = exports.VexillaFeatureType || (exports.VexillaFeatureType = {}));
var VexillaClient = /** @class */ (function () {
    function VexillaClient(config) {
        this.customInstanceHash = "";
        this.baseUrl = config.baseUrl;
        this.environment = config.environment || "prod";
        this.customInstanceHash = config.customInstanceHash;
    }
    VexillaClient.prototype.getFlags = function (fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var flagsResponse, flags;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1["default"].get(this.baseUrl + "/" + fileName)];
                    case 1:
                        flagsResponse = _a.sent();
                        flags = flagsResponse.data;
                        this.flags = flags.environments[this.environment];
                        return [2 /*return*/, this];
                }
            });
        });
    };
    VexillaClient.prototype.should = function (flagName, groupName) {
        if (groupName === void 0) { groupName = "untagged"; }
        if (!this.flags) {
            return false;
        }
        var flag = this.flags[groupName][flagName];
        var _should = false;
        switch (flag.type) {
            case VexillaFeatureType.TOGGLE:
                _should = flag.value;
                break;
            case VexillaFeatureType.GRADUAL:
                flag = flag;
                _should = this.getInstancePercentile(flag.seed) <= flag.value;
                break;
            default:
                throw Error("Unsupported Feature Type: " + flag.type);
        }
        return _should;
    };
    VexillaClient.prototype.getInstancePercentile = function (seed) {
        if (seed <= 0 || seed > 1) {
            throw new Error("seed must be a number value greater than 0 and less than or equal to 1");
        }
        if (!this.customInstanceHash) {
            throw new Error("customInstanceHash config must be defined when using 'gradual' Feature Types");
        }
        var hasher = new hasher_1["default"](seed);
        return hasher.hashString(this.customInstanceHash);
    };
    return VexillaClient;
}());
exports.VexillaClient = VexillaClient;
